import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api, { formatApiErrorDetail } from "../lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // null = checking, false = not auth, object = auth
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch (e) {
            setUser(false);
            return false;
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // If returning from OAuth callback, skip the /me check; AuthCallback handles it.
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        checkAuth();
    }, [checkAuth]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.token && typeof window !== "undefined") localStorage.setItem("auth_token", data.token);
        setUser(data);
        return data;
    };

    const register = async (name, email, password) => {
        const { data } = await api.post("/auth/register", { name, email, password });
        if (data.token && typeof window !== "undefined") localStorage.setItem("auth_token", data.token);
        setUser(data);
        return data;
    };

    const logout = async () => {
        if (typeof window !== "undefined" && sessionStorage.getItem("imp_token")) {
            sessionStorage.removeItem("imp_token");
            setUser(false);
            return;
        }
        try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
        if (typeof window !== "undefined") localStorage.removeItem("auth_token");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, refresh: checkAuth, formatApiErrorDetail }}>
            {children}
        </AuthContext.Provider>
    );
};
